export default {
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, data) {
    if(data.type === 'form') {
      state.formLoading = data.value;
    } else {
      state.loading = data.value;
    }
  },
  setUser(state, payload) {
    state.user = payload;
  },
  setUserRoles(state, payload) {
    state.roles = payload;
  },
  setUserPermissions(state, payload) {
    state.permissions = payload
  },
  setCustomer(state, customer) {
    state.customerDetails = customer;
  },
  setCustomers(state, payload) {
    if(payload.type === 'active') {
      state.activeCustomers = payload.data;
    } else {
      state.inactiveCustomers = payload.data;
    }
  },
  setLoans(state,payload) {
    state.loans = payload;
  },
  setPendingLoans(state, payload) {
    state.pendingloans = payload;
  },
  setActiveLoans(state,payload) {
    state.activeloans = payload;
  },
  setDeclinedLoans(state, payload) {
    state.declinedloans = payload;
  },
  setApprovedLoans(state,payload) {
    state.approvedloans = payload;
  },
  setDisbursedLoans(state,payload) {
    state.disbursedloans = payload;
  },
  setLoanDetails(state, payload) {
    state.loanDetails = payload;
  },
  setLoanTypes(state, payload) {
    state.loanTypes = payload;
  },
  setLoanReasons(state, payload) {
    state.loanReasons = payload;
  },
  setUserDetails(state, payload) {
    state.userDetails = payload;
  },
  setRedflag(state, payload) {
    state.userRedflag = payload;
  }
}